import { useEffect } from "react";
import { updateZendeskTheme } from "@/utils/zendesk";
import { useTheme } from "@/v2/hooks";

/**
 * Hook that syncs Zendesk Web Widget colors with the current whitelabel theme.
 * Updates in real-time when the theme changes (e.g., super admin switching whitelabels).
 */
export const useZendeskTheme = () => {
  const theme = useTheme();

  useEffect(() => {
    updateZendeskTheme(theme);
  }, [theme?.navBackground, theme?.navText]);
};
